import { ConsignmentType } from './poz-consignment';

export class ConsignmentConfig {
  prefixConsignment: string = 'CS/{year}/';
  defaultConsignmentType: ConsignmentType = 'deposit';
  consignmentHeader: string = '';
  consignmentFooter: string = '';
  additionalIntakeText: string = '';
  additionalReturnText: string = '';
  additionalPayoutStatementText: string = '';
}
